/**
 * Frequency cap for the post-download editor promo, on the same pattern as
 * proUpsellStorage: at most once per user per day, keyed by the
 * authorized-link token, in localStorage so a reload or a same-day second
 * download doesn't re-show it.
 */
const PREFIX = "editor_promo_last_shown_";

/** YYYY-MM-DD in the visitor's own local timezone, as proUpsellStorage does. */
function localDateString(date: Date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function hasSeenEditorPromoToday(userId: string): boolean {
  if (!userId) return false;
  return localStorage.getItem(PREFIX + userId) === localDateString();
}

export function markEditorPromoShown(userId: string): void {
  if (!userId) return;
  localStorage.setItem(PREFIX + userId, localDateString());
}

/**
 * Permanent suppression once someone has clicked through to Stitch Studio:
 * they know it exists, so pointing them at it again is just an interruption.
 * A new key, not the old editor's: having found /editor isn't having found
 * Studio, so those visitors get the card again.
 */
const CLICKED_PREFIX = "studio_promo_clicked_";

export function hasClickedEditorPromo(userId: string): boolean {
  if (!userId) return false;
  return localStorage.getItem(CLICKED_PREFIX + userId) === "1";
}

export function markEditorPromoClicked(userId: string): void {
  if (!userId) return;
  localStorage.setItem(CLICKED_PREFIX + userId, "1");
}
